module.exports = __webpack_public_path__ + "static/media/provi.a1712630.svg";